<template>
  <Form ref="formInline" :model="formInline" inline>
    <!-- <FormItem prop="user">
            <Input type="text" v-model="formInline.user" placeholder="Username">
            </Input>
        </FormItem>
        <FormItem prop="password">
            <Input type="text" v-model="formInline.password" placeholder="Password">
            </Input>
        </FormItem>
         <FormItem prop="time">
            <DatePicker type="date" placeholder="Select date" v-model="formInline.time"></DatePicker>
        </FormItem>
         <FormItem prop="time">
            <DatePicker type="date" placeholder="Select date" v-model="formInline.time"></DatePicker>
        </FormItem>
         <FormItem prop="time">
            <DatePicker type="date" placeholder="Select date" v-model="formInline.time"></DatePicker>
        </FormItem>
         <FormItem prop="time">
            <DatePicker type="date" placeholder="Select date" v-model="formInline.time"></DatePicker>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit">Signin</Button>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit">Signin</Button>
        </FormItem>
         <FormItem>
            <Button type="primary" @click="handleSubmit">Signin</Button>
        </FormItem>
         <FormItem>
            <Button type="primary" @click="handleSubmit">Signin</Button>
        </FormItem>
         <FormItem>
            <Button type="primary" @click="handleSubmit">Signin</Button>
    </FormItem>-->
    <FormItem v-for="(item,index) in form" :key="index">
      <Input style="width:180px"
        v-if="item.fromType==='Input'"
        :type="item.type"
        v-model="formInline[item.value]"
        :placeholder="item.place"
      ></Input>
      <DatePicker style="width:180px"
        v-if="item.fromType==='DatePicker'"
        :type="item.type"
        :placeholder="item.place"
        v-model="formInline[item.value]"
      ></DatePicker>
      <Select style="width:180px"
        v-if="item.fromType==='Select'"
        v-model="formInline[item.value]"
        :placeholder="item.place"
      >
        <Option v-for="(a,index) in item.arr" :value="a.code" :key="index">{{a.name}}</Option>
      </Select>
      <Button
        v-if="item.fromType==='Button'"
        :type="item.type"
        @click="handleSubmit(item.event)"
      >{{item.place}}</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  props: {
    form: {
      type: Array
    },
    formInline: {
      type: Object
    }
  },
  data() {
    return {};
  },

  methods: {
    handleSubmit(type) {
      let obj = {
        type,
        ...this.formInline
      };
      this.$emit("on-event", obj);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/SearchHeader.vue